import { render, staticRenderFns } from "./fightcamp-connect.vue?vue&type=template&id=54f04f5b&scoped=true&"
import script from "./fightcamp-connect.vue?vue&type=script&lang=ts&"
export * from "./fightcamp-connect.vue?vue&type=script&lang=ts&"
import style0 from "./fightcamp-connect.vue?vue&type=style&index=0&id=54f04f5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f04f5b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewsGrid: require('/opt/build/repo/apps/shop/components/storyblok/ReviewsGrid/ReviewsGrid.vue').default})
